import React from "react";
import { useStaticQuery, Link, graphql } from "gatsby";
import styled from "styled-components";
// import Image from "gatsby-image";
import { StaticImage } from "gatsby-plugin-image";

const color = {
  black: "#282a36",
  white: "#f8f8f2",
  green: "#50fa7b",
  orange: "#ffb86c",
  pink: "#ff79c6",
  purple: "#bd93f9",
};
const FooterSimple = styled.footer`
  padding: 1rem;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  z-index: 2;
  margin-top: 2rem;

  a {
    font-style: normal;
  }
  /* a:before {
    display: none;
  } */

  /* @media (max-width: 768px) {
    position: fixed;
    width: 100%;
    padding-bottom: 0;
    bottom: 0;
    left: 0;
    display: inline-flex;
    flex-direction: row;
    align-items: center;
  } */
`;
const Navigation = styled.nav`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: 1rem;

  > a {
    /* font-size: 1rem; */
    /* text-decoration: none; */
    /* box-shadow: none; */
    /* text-align: center; */
  }
  /* @media (max-width: 768px) {
    flex-direction: row;
    width: 100%;
    justify-content: space-around;
    align-items: center;
    display: flex;
  } */
`;

// const SubNav = styled.div`
//   left: 0;
//   flex-direction: row;
//   display: inline-flex;
//   text-align: center;
//   width: 100%;
//   text-align: center;
//   justify-content: center;

//   > a {
//     font-size: 0.8rem;
//     margin: 0 1vw;
//   }
// `;
// const Social = styled(SubNav)`
//   width: 100%;
//   justify-content: space-around;
//   > a {
//     margin: 0;
//   }
// `;
// const Span = styled.span`
//   text-decoration: none;
// `;

export default () => {
  const data = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          siteTitle
          subMenu {
            link
            name
          }
          social {
            twitter
            email
            linkedin
            github
          }
        }
      }
    }
  `);

  const { social, subMenu } = data.site.siteMetadata;
  return (
    <FooterSimple>
      <Navigation color={color}>
        <a
          href={`https://v1.chrisshimmin.com`}
          target="_blank"
          rel="noopener noreferrer"
        >
          <span color={color.black}>{subMenu[0].name}</span>
        </a>
        <a
          href={`https://v2.chrisshimmin.com`}
          target="_blank"
          rel="noopener noreferrer"
        >
          <span color={color.black}>{subMenu[1].name}</span>
        </a>
        <a
          href={`https://v3.chrisshimmin.com`}
          target="_blank"
          rel="noopener noreferrer"
        >
          <span color={color.black}>{subMenu[2].name}</span>
        </a>
      </Navigation>
    </FooterSimple>
  );
};
